import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M4 19h16v-7h2v8a1 1 0 01-1 1H3a1 1 0 01-1-1v-8h2v7z"/>
    <path fill="#34CEFF" d="M18 9h-5v7h-2V9H6l6-6 6 6z"/>
  </SvgIcon>
);